const _ = require('lodash');

function ReturnToTopDirective(enabledOnPage, $, $window, breakpointsService) {
    return {
        restrict: 'E',
        scope: {},
        template: require('./return-to-top-template.html'),
        link(scope) {

            const isEnabled = !!enabledOnPage[$window.location.pathname.toLowerCase()];
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            scope.cssStyle = isMobile ? 'return-to-top mobile' : 'return-to-top';
            if (!isEnabled) return;

            const container = $($window);
            scope.showReturn = false;

            function hasScrolled() {
                scope.showReturn = (container.scrollTop() >= 50);
            }

            scope.backToTop = function () {
                const scrollElm = breakpointsService.getScrollElement();
                scrollElm.animate({ scrollTop: 0 }, 200);
            };

            const debouncedScroll = _.debounce(hasScrolled, 250, { leading: true, trailing: true });

            const registerScrollListeners = (eventName) => {
                return () => {
                    container[eventName]('scroll', debouncedScroll);
                    container[eventName]('wheel', debouncedScroll);
                    container[eventName]('mousewheel', debouncedScroll);
                    container[eventName]('touchmove', debouncedScroll);
                    container[eventName]('keydown', debouncedScroll);
                };
            };

            const unbindListeners = registerScrollListeners('unbind');
            const bindListeners = registerScrollListeners('bind');

            scope.$on('$destroy', unbindListeners);
            bindListeners();
        }
    };
}

module.exports = ReturnToTopDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/return-to-top/return-to-top-directive.js
 **/